import { orchestrator } from 'satcheljs';
import getItemIdsToShowFromNodeIds from 'owa-mail-store/lib/selectors/getItemIdsToShowFromNodeIds';
import { listViewStore } from 'owa-mail-list-store';
import markItemsJunkNotJunkBasedOnNodeIds from '../actions/actionCreators/markItemsJunkNotJunkBasedOnNodeIds';
import createItemContextsForDeleteStoreUpdate from '../actions/helpers/createItemContextsForDeleteStoreUpdate';
import markItemsJunkNotJunkBasedOnItemIds from '../actions/markAsJunk/markItemsJunkNotJunkBasedOnItemIds';
import deleteItemsStoreUpdate from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';
import { selectNextItemPart } from 'owa-mail-actions/lib/mailListSelectionActions';

export default orchestrator(markItemsJunkNotJunkBasedOnNodeIds, actionMessage => {
    const itemIds = getItemIdsToShowFromNodeIds(actionMessage.nodeIds);
    const tableView = listViewStore.tableViews.get(actionMessage.tableViewId);

    selectNextItemPart(listViewStore.expandedConversationViewState.expandedRowKey, tableView);

    markItemsJunkNotJunkBasedOnItemIds(
        itemIds,
        actionMessage.isJunkValueToSet,
        actionMessage.actionSource,
        tableView,
        null,
        () => {
            const itemContexts = createItemContextsForDeleteStoreUpdate(itemIds);

            // Dispatch action to update the store state
            deleteItemsStoreUpdate(itemContexts, tableView.tableQuery.folderId);
        }
    );
});
